import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

export default function MultiplierStock({
  open,
  setOpen,
  onApply,
  defaultValue = 10,
}) {
  const [count, setCount] = useState(defaultValue);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setCount(defaultValue);
      // autofocus when dialog opens
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, [open, defaultValue]);

  const close = () => setOpen(false);

  const submit = (e) => {
    e?.preventDefault();
    const n = Number(count);
    if (!Number.isInteger(n) || n < 1) return; // basic guard
    onApply?.(n);
    close();
  };

  return (
    <Dialog open={open} onClose={close} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all
                       data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out
                       data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-sm
                       data-closed:sm:translate-y-0 data-closed:sm:scale-95"
          >
            <form onSubmit={submit}>
              <div className="bg-white px-5 pt-5 pb-4 sm:p-6 sm:pb-4">
                <DialogTitle className="text-base font-semibold text-gray-900">
                  Multiply Entries
                </DialogTitle>

                <p className="mt-1 text-sm text-gray-500">
                  Enter how many copies you want to add (e.g., duplicate the
                  first item).
                </p>

                <div className="mt-4">
                  <label
                    htmlFor="multiplier"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Count
                  </label>
                  <input
                    id="multiplier"
                    ref={inputRef}
                    type="number"
                    min={1}
                    step={1}
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white
                               placeholder:text-gray-400 focus:outline-none focus:ring-2
                               focus:ring-violet-300 focus:border-violet-300"
                    placeholder="e.g. 10"
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Press Enter to apply.
                  </p>
                </div>
              </div>

              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-2">
                <button
                  type="submit"
                  className="inline-flex w-full justify-center rounded-md bg-violet-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-violet-500 sm:w-auto"
                >
                  Apply
                </button>
                <button
                  type="button"
                  onClick={close}
                  className="mt-2 sm:mt-0 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
